import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-87" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-88" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-89" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif"
      }} data-id="element-90" data-mp="nc876ng09kij">
          REHABILITATE ANY JOINT SAFELY AND PROGRESSIVELY
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "9px"
      }} data-id="element-91" data-mp="3814bdoempwnt">
          Complete injury recovery using a clinical method
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-92" data-mp="39al8kaui8i1k">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-93" data-mp="358rckfv9827q" />
          <img src="https://cdn.magicpatterns.com/uploads/31xXxYH4mcqcoPv5xcxfry/ChatGPT_Image_4_sept_2026,_01_32_08_birefnet.webp" alt="The 360° Injury Rehab Visual System — ebook plus 5 bonuses in digital format" width={1248} height={1248} sizes="(min-width: 640px) 448px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" style={{
          marginTop: "-19px",
          marginBottom: "-19px"
        }} data-id="element-94" data-mp="2qkmune40zuq0" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-95" data-mp="nb1kz5gpvtwy">
          ⭐ 4.9 (500+ satisfied professionals and individuals with injuries) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-96" data-mp="161ay3ae1l63f">
          <CTAButton href="#value" data-id="element-97" data-mp="15zq35jntfl51">See the 360 system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-98" data-mp="111es55lsb4l8">
            COMPLETE INJURY REHABILITATION COMBO 2026. The #1 system for physical education
            teachers, personal trainers, kinesiologists and individuals with injuries who need a
            real, progressive and ready-to-use protocol.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-99" data-mp="3htpwlnn2mckc">
            Shoulder · Knee · Ankle · Spine · Hip · Elbow
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-100" data-mp="2b1ra8793v9g4">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-101" data-mp="2g2584wgzt30f">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-102" data-mp="2p10imkr2kz9j" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-103" data-mp="2txhbfs97s1sy">
            Ebook + 5 bonuses · 150+ pages - Everything you need in one place.
          </p>
        </div>

        

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-104" data-mp="zlsxntepy5a5">
          🔥 Limited-time offer · Then the price goes back up to $54
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-105" data-mp="3hqse8an9c3l1">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-106" data-mp="3ct0o9m66arjh" />
          25 people are watching this product right now
        </p>
      </div>
    </header>;
}